import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, } from "react-hook-form";
import { checkAccess } from '../../../actions/securityactions'
import CustomPager from '../../../components/custompager';
import * as actions from '../actions/complaintandfeedbackactions.js'
import * as appConstants from '../../../overrides/appconstants.js'
import CustomModal from '../../../components/CustomModal'
import ReCAPTCHA from "react-google-recaptcha";
import complaintsservice from '../services/complaintandfeedbackservice.js'
import * as appActions from '../../../actions/appactions';
import { uploadFile } from '../../../infrastructure/httphelper';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';

export default function WhistleBlowing() {
    const state = useSelector(state => state.complaintandfeedbackReducer);
    let modalsState = state.modalsState;
    let masters = state.masters;
    let complaintDetails = state.complaintDetails;
    const refTabs = useRef(null);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const navigate = useNavigate();

    const { register: registerWhistleBlowing, handleSubmit: handleSubmitWhistleBlowing, setValue: setWhistleBlowingValue, reset: resetWhistleBlowing,
        formState: { errors: errorsWhistleBlowing }, watch } = useForm({
        });
    let whistleBlowing = state.whistleBlowing;
    let validationsErrorMessages = state?.validationsErrorMessages;
    const [phoneMessage, setphoneMessage] = useState(null);
    const [emailMessage, setemailMessage] = useState(null);
    const [eIdMessage, seteIdMessage] = useState(null);
    const [localErrors, setLocalErrors] = useState(errorsWhistleBlowing || {});
    const [captchaCompleted, setCaptchaCompleted] = useState(false);
    const [captchaError, setCaptchaError] = useState(false);


    useEffect(() => {
        let valuesToMap = [
            { "fullName": whistleBlowing.fullName },
            { "email": whistleBlowing.email },
            { "mobileNumber": whistleBlowing.mobileNumber },
            { "comment": whistleBlowing.comment },
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setWhistleBlowingValue(key, i[key])));
    }, [whistleBlowing]);

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const onFileChange = async (e) => {
        if (!e.target || e.target.files.length == 0)
            return;
        let file = e.target.files[0];
        let docId = null;
        const inputName = e.target.name;
        // const docIdEncrypted = docId;
        const type = e.fileType;
        const field = "fileInput";
        const name = file.name;
        const date = new Date();
        const docIdEncrypted = await uploadFile(file);
        let id = 0;
        if (inputName == "selectedFile1") {
            id = 0;
        }
        if (inputName == "selectedFile2") {
            id = 1;
        }
        if (inputName == "selectedFile3") {
            id = 2;
        }
        dispatch(actions.updateFileChange({ id, field, name, docIdEncrypted, type, date }));
    };

    const handleWhistleBlowingChange = (e) => {
        let { name, value } = e.target;
      
        if (name == "email") {
            const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            dispatch(actions.updateWhistleBlowingParams({ name, value }));
            if (!emailRegex.test(value)) {
                setemailMessage("Invalid Email ID");
                dispatch(actions.changeValidationMessage({ name: 'emailMessage', value: "Invalid Email Id" }))
                return;
            }
            setemailMessage(null);
            dispatch(actions.changeValidationMessage({ name: 'emailMessage', value: null }))
        }
        dispatch(actions.updateWhistleBlowingParams({ name, value }));
        
    }

  const handleCaptchaChange = (value) => {
        if (value) {
            setCaptchaCompleted(true);
            setCaptchaError(false);
        } else {
            setCaptchaCompleted(false);
            setCaptchaError(true);
            {
                let dialogeData = {
                       message: `Please complete the CAPTCHA.`,
                       showConfirmPopup: true,
                       isConfirm: false,
                       isInfo: true,
                     }
               
                      dispatch(actions.toggleConfirmPopup(dialogeData));
                     return true;
             }
        }
    };
    const onSubmitWhistleBlowing = async () => {
      if (!captchaCompleted) {
                  setCaptchaError(true);
                  {
                      let dialogeData = {
                             message: `Please complete the CAPTCHA.`,
                             showConfirmPopup: true,
                             isConfirm: false,
                             isInfo: true,
                           }
                     
                           await dispatch(actions.toggleConfirmPopup(dialogeData));
                           return true;
                   }
                 
              }
         {
            setIsButtonDisabled(true);
            try {
        await dispatch(actions.saveWhistleBlowing());
       // await dispatch(actions.saveDocuments());
        }
    catch (error) {
        console.error("Error saving complaint details:", error);
      } finally {
        // Enable the button after the function completes
        setIsButtonDisabled(false);
      }
    }

    }

    const scrollToTabs = () => {
        refTabs.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const onErrorWhistleBlowing = (errorsWhistleBlowing, e) => console.log(errorsWhistleBlowing, e);
    console.log("whistleBlowing", whistleBlowing);
    const dispatch = useDispatch();

    let FullName =
            <input
                className={errorsWhistleBlowing.fullName ? 'form-control is-invalid' : 'form-control'}
                placeholder="Enter Full Name"
                id="fullName"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && whistleBlowing.complaintNumber != null}
                name="fullName"
                type="text"
                {...registerWhistleBlowing("fullName",
                    {
                        onChange: (e) => handleWhistleBlowingChange(e)
                    })}
            // onChange={handleWhistleBlowingChange}
            // value={treatySearch.treatyCode}
            />

        let Email =
            <input
                className={errorsWhistleBlowing.email || emailMessage ? 'form-control is-invalid' : 'form-control'}
                placeholder="Enter Email"
                id="email"
                name="email"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && whistleBlowing.complaintNumber != null}
                type="text"
                {...registerWhistleBlowing("email", {
                    required: true,
                    validate: {
                        emailcheck: (v) => isValidEmail(v)
                    },
                    onChange: (e) => handleWhistleBlowingChange(e)
                })}
            // value={treatySearch.treatyCode}
            />
           
        let MobileNumber = <input className={errorsWhistleBlowing.mobileNumber ? 'form-select is-invalid' : 'form-control'}
        //placeholder="05X-XXXXXXX / 0X-XXXXXXX"
        placeholder="5XXXXXXXX"
        id="mobileNumber"
        name="mobileNumber"
        type="text"
        {...registerWhistleBlowing("mobileNumber", {
            required: true,
            //pattern: { value: /(^[0][5][0,5,2,6,4,8]{1}[-]?[0-9]{7}$)|(^[0][2,3,4,5,6,7,9]{1}[-]?[0-9]{7}$)/, message: "Format: 05X-XXXXXXX / 0X-XXXXXXX" },
            pattern: { value: /(^[5][0,5,2,6,4,8]{1}[0-9]{7}$)/, message: "Format: 5XXXXXXXX" },
            onChange: (value) => handleWhistleBlowingChange(value)
        })}
    />

        
        let Message = <textarea className={errorsWhistleBlowing.comment ? 'form-control is-invalid' : 'form-control'}
            class="form-control" aria-label="With textarea"
            placeholder=""
            id="comment"
            rows={5}
            // style={{ width: "1500px", height: "200px" }}
            name="comment"
            type="textArea"
            {...registerWhistleBlowing("comment", { required: true, onChange: (e) => handleWhistleBlowingChange(e) })}
            textarea />



   
         let Captcha = <ReCAPTCHA
            sitekey={appConstants.CAPTCHA_SITE_KEY}
            // sitekey="6Lflq9QqAAAAACQYldy2S3ece4KtQCKS37F1dfEy"
            onChange={handleCaptchaChange}
        />  
        return (
            <>
                               <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-xxl-6 col-lg-5">
                                    <div class="card">
                                        <div class="card-body p-4">
                                            <span class="logo-lg d-block mb-3">
                                                <div class="text-center w-75 m-auto">
                                                <h4 class="text-black text-center mt-0 mb-3 fw-bold"> WhistleBlower Channel</h4>
                                            </div>
                                           </span>
                                            <ul className="nav nav-tabs nav-bordered my-3">
                                            </ul>
                                          <form className="form-group needs-validation"
                                                onSubmit={handleSubmitWhistleBlowing(onSubmitWhistleBlowing, onErrorWhistleBlowing) }noValidate="noValidate">
                                                <div class="mb-3">
                                                        <label  class="form-check text-justify" className="fs-6">
                                                         This channel is intended solely for reporting suspected fraud, misconduct, unethical behaviour, or other wrongdoing involving Al Sagr National Insurance Company’s employees, service providers, business partners, or any other related party.
                                                         Please describe your concern clearly in the Whistleblower Form and provide all available information, including the identity of the person(s) involved, the date and location of the incident, and the nature of the suspected wrongdoing.
                                                         You may submit your report anonymously; however, providing your contact details may assist us in obtaining further information and conducting a thorough investigation.
                                                         All information submitted through this form will be treated with strict confidentiality and accessed only by authorised personnel responsible for reviewing and investigating whistleblower reports.
                                                         Alternatively, you may submit your report by email at whistleblow@alsagrins.ae.
                                                        </label>
                                                    
                                                </div>   
                                                 <div class="mb-3">
                                                        <label className="text-danger fw-bold fs-5">
                                                           Please note : Incomplete information may prevent us from concluding the investigation. Providing your contact details
                                                            (mobile number or email address) is recommended for any required follow-up.
                                                        </label>
                                                    
                                                </div>
                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label"> Full Name/الأسم</label>
                                                    {FullName}
                                                </div>

                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Email ID/البريد الإلكتروني</label>
                                                    {Email}
                                                </div>

                                                <div className="position-relative mb-3">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='text-danger'>*</span> Mobile Number/رقم الموبايل</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text">+971</span>
                                                        </div>
                                                        {MobileNumber}
                                                    </div>
                                                    {(errorsWhistleBlowing.mobileNumber || phoneMessage) && (
                                                        <div className='text-danger'>
                                                            {errorsWhistleBlowing.mobileNumber?.message || phoneMessage}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Complaint Details/تفاصيل الشكوى</label>
                                                    {Message}
                                                    {errorsWhistleBlowing.comment && <span className='redstar'> {errorsWhistleBlowing.comment.message}</span>}
                                                    <p className='mb-0'>{watch("comment", "")?.length ?? 0} / 3999</p>
                                                </div>

                                                <div class="mb-3">
                                                    <div className="row g-2">
                                                        <div className="mb-4 col-md-12">
                                                            <div className="row">
                                                                <label className="form-label">Document Upload/تحميل المستندات</label>
                                                                <div className="col-sm-6">
                                                                    <input className="form-control"
                                                                        type="file"
                                                                        id="inputGroupFile1"
                                                                        label="selectedFile1"
                                                                        name="selectedFile1"
                                                                        {...registerWhistleBlowing("selectedFile1", { onChange: (e) => onFileChange(e) })} />
                                                                </div>
                                                                <div className="col-sm-6 text-end">
                                                                    <input className="form-control"
                                                                        type="file"
                                                                        id="inputGroupFile2"
                                                                        label="selectedFile2"
                                                                        name="selectedFile2"
                                                                        {...registerWhistleBlowing("selectedFile2", { onChange: (e) => onFileChange(e) })} />
                                                                </div>
                                                                <div className="mt-3 col-sm-6">
                                                                    <input className="form-control"
                                                                        type="file"
                                                                        id="inputGroupFile3"
                                                                        label="selectedFile3"
                                                                        name="selectedFile3"
                                                                        {...registerWhistleBlowing("selectedFile3", { onChange: (e) => onFileChange(e) })} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    {Captcha}
                                                  {captchaError && (<div className="invalid-feedback d-block">Please complete the CAPTCHA.</div>)}
                                                </div>
                                           
                                                <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                    // onClick={handleNext}
                                                    disabled={isButtonDisabled}
                                                    >
                                                        Save
                                                    </Button>

                                                </Box>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            </div>
                      </div>     </div>
            </>
        )
    }




